module.exports = __webpack_public_path__ + "static/media/fingerprint-scan-animation.7903eb5d.gif";